<div class="center-content">
    <div mat-dialog-content style="width: 100%; margin: 0px">
        <h4 [innerHtml]="text"></h4>
    </div>
    <mat-dialog-actions align="center">
        <button *ngIf="type === 1" mat-button class="save-btn" (click)="confirm()">Yes</button>
        <button *ngIf="type === 1" mat-button class="cancel-btn" [mat-dialog-close]="false">Cancel</button>
        <button *ngIf="type === 2" mat-button class="save-btn" [mat-dialog-close]="false">Ok</button>
    </mat-dialog-actions>
</div>
